import {useContext} from 'react'
import {PurchaserReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {PURCHASER_REPORT_COLUMNS} from '../../utils'
import PurchaserReportRow from './PurchaserReportRow'
import {parsePurchaserReportRow} from '../../parsings'
import { formatPrice, formatToIndianNumber } from '../../../../utils/common'

const PurchaserReportTable = () => {
  const {purchaserReportData, isPurchaserReportLoading, filters, onSortingChange} = useContext(PurchaserReportContext)

  return (
    <DynamicTable
      data={purchaserReportData}
      sortableColumns={PURCHASER_REPORT_COLUMNS}
      loading={isPurchaserReportLoading}
      TableRow={PurchaserReportRow}
      noDataMessage='No purchaser reports found'
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      filters={filters}
      onSortingChange={onSortingChange}
      rowParsingFunction={parsePurchaserReportRow}
      tableFooter={({columnTotals}: any) => (
        <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
          <tr>
            <td>TOTAL</td>
            <td>{formatToIndianNumber(columnTotals?.total_orders)}</td>
            <td>{formatPrice(columnTotals.total_cost, false)}</td>
            <td>{formatPrice(columnTotals.total_sales, false)}</td>
            <td>{formatPrice(columnTotals.total_profit, false)}</td>
          </tr>
        </tfoot>
      )}
    />
  )
}

export default PurchaserReportTable
